import ProjectCommentViewModel from "../../viewModel/ProjectCommentViewModel";
import ReplyCard from "../ReplyCard/ReplyCard";

import * as S from "./ReplyList.style";

interface ReplyListProps {
  currentUserId: number;
  projectId: string;
  commentId: number;
  replyList: ProjectCommentViewModel[];
}

const ReplyList = ({
  currentUserId,
  projectId,
  commentId,
  replyList,
}: ReplyListProps) => {
  return (
    <S.ReplyListWrapper>
      {replyList?.map((reply) => (
        <ReplyCard
          key={reply.id}
          isMySelf={reply.authorId === currentUserId}
          projectId={projectId}
          commentId={commentId}
          replyId={reply.id}
          commenterName={reply.authorName}
          authorName={reply.authorName}
          authorId={reply.authorId}
          authorProfile={reply.profileImage}
          repliedPayload={reply.content}
          repliedAt={reply.createdAt}
        />
      ))}
    </S.ReplyListWrapper>
  );
};

export default ReplyList;
